import videojs from "video.js";

export default class VideoUtil {
  private videoElement: HTMLVideoElement | null = null;
  private config: any = {
    controls: true,
    bigPlayButton: true,
    preload: "auto",
    controlBar: {
      children: [
        { name: 'playToggle' },
        // { name: 'currentTimeDisplay' }, // 当前已播放时间
        { name: 'progressControl' },
        // { name: 'durationDisplay' }, // 总时间
        { // 倍数播放
          name: 'playbackRateMenuButton',
        },
        {
          name: 'volumePanel', // 音量控制
        },
        { name: 'FullscreenToggle' }, // 全屏
      ],
    },
  };

  private player: videojs.Player | null = null;

  constructor(ve: HTMLVideoElement | null, config: any) {
    this.videoElement = ve;
    this.config = Object.assign({}, this.config, config);
    this.initVideo();
  }

  public static init(ve: HTMLVideoElement | null, config: any): VideoUtil {
    return new VideoUtil(ve, config);
  }

  public initVideo(): void {
    if (this.videoElement === null) return;

    this.player = videojs(this.videoElement, this.config, () => {
      // console.log("player is ready");
    });
  }

  public play(): void {
    if (this.player != null) {
      this.player.play();
    }
  }

  public pause(): void {
    if (this.player != null) {
      this.player.pause();
    }
  }

  public dispose(): void {
    if (this.player) {
      this.player.dispose();
    }
  }
}